module.exports = __webpack_public_path__ + "static/media/instagram-icon.366aa884.svg";